import { HomepageCarousel } from './ui/HomepageCarousel.jsx'
import './ui/HomepageCarousel.scss'

export default HomepageCarousel
